// extracted by mini-css-extract-plugin
module.exports = {"grayframe":"styles_grayframe__scdpQ","printIcon":"styles_printIcon__2qaww","sendButton":"styles_sendButton__2JpSt"};